import React from 'react';
import { connect } from 'react-redux';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { socialDefaults } from "./constants";
import { Translate } from "react-localize-redux";
import './styles.scss';

export class SocialDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { dropdownOpen: false };
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  render() {
    const { onChange } = this.props;

    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle className="privacy-dropdown-toggle social-add-toggle">
          <i className="fa fa-plus"></i> <Translate id="addText" />
        </DropdownToggle>
        <DropdownMenu className="privacy-dropdown-menu">
          {socialDefaults.map(option =>
            <DropdownItem onClick={() => onChange(option)}>
              {option.social_type}
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

const mapStateToProps = ({ profile }) => ({ profileId: profile.profile.id });

export default connect(mapStateToProps)(SocialDropdown);


// WEBPACK FOOTER //
// ./src/components/forms/SocialFormPanel/SocialDropdown.jsx